import { jsx as n, jsxs as j, Fragment as q } from "react/jsx-runtime";
import { useState as e, useEffect as w } from "react";
import { Modal as M } from "../Modal/Modal.js";
import { ProductSelected as N } from "./components/ProductSelected.js";
import { SimilarProducts as k } from "./components/SimilarProducts.js";
import { ModalFooter as v } from "./components/ModalFooter.js";
/* empty css                               */import { Skeleton as A } from "@acctglobal/skeleton";
import { getProductsSimilars as E } from "./api/getProductsSimilars.js";
import _ from "../../hooks/useAnalitcsEvents.js";
import { NoSimilarProduct as J } from "./components/NoSimilarProduct.js";
import { getOrderForm as L } from "./api/getOrderForm.js";
import { postChangeOrder as T } from "./api/postChangeOrder.js";
const oo = ({
  selectedItem: o,
  postalCode: S,
  orderFormId: f,
  isClubClient: h,
  isOpen: y,
  environment: O,
  setIsOpen: l,
  saveSelectedSimilarProduct: m
}) => {
  const [u, b] = e(), [P, s] = e(!1), a = O === "io", { genericTaggingEvent: C } = _(), [r, p] = e({ itemId: "" });
  return w(() => {
    (async () => {
      s(!0);
      try {
        const t = await E({
          postalCode: S,
          selectedItem: o,
          isIO: a
        }), d = (t == null ? void 0 : t.products) || [];
        b(d);
      } finally {
        s(!1);
      }
    })(), (async () => {
      var t, d;
      s(!0);
      try {
        const c = await L(f, a), i = ((d = (t = c == null ? void 0 : c.customData) == null ? void 0 : t.customApps) == null ? void 0 : d.find(
          (x) => x.id === "janis"
        )) || null;
        let g = {};
        i != null && i.fields.idSubstitutionCriterias && (g = JSON.parse(
          i == null ? void 0 : i.fields.idSubstitutionCriterias
        ));
        const F = o == null ? void 0 : o.productOriginId;
        p({
          itemId: `${g[F]}`
        });
      } finally {
        s(!1);
      }
    })();
  }, []), /* @__PURE__ */ n(
    M,
    {
      isOpen: y,
      setIsOpen: l,
      className: "change-order-modal",
      title: "Produto com estoque baixo",
      Footer: /* @__PURE__ */ n(
        v,
        {
          saveSelectedSimilarProduct: () => {
            T(
              f,
              a,
              o.productOriginId,
              r.itemId
            ), r && (m == null || m(r), C("salvar_substituto", {
              name: o.name,
              replacement_item: r == null ? void 0 : r.name
            })), l(!1);
          }
        }
      ),
      children: P ? /* @__PURE__ */ n(
        A,
        {
          width: a ? "100%" : "90%",
          height: a ? 600 : 425,
          backgroundColor: "var(--color-grayScale-faded)",
          margin: "auto",
          animation: !0
        }
      ) : /* @__PURE__ */ j(q, { children: [
        o && /* @__PURE__ */ n(N, { selectedItem: o }),
        u && u.length > 0 ? /* @__PURE__ */ n(
          k,
          {
            isClubClient: h,
            similarProductSelect: r,
            setSimilarProductSelect: p,
            products: u
          }
        ) : /* @__PURE__ */ n(J, {})
      ] })
    }
  );
};
export {
  oo as ChangeOrderModal
};
